window.addEventListener('load', () => {
    const $breadcrumbsItems = Array.from(document.querySelectorAll('.breadcrumbs__list-item'))
    for (const $b of $breadcrumbsItems) {
        if (getComputedStyle($b, 'before')) {
            $b.addEventListener('click', () => {
                $b.parentNode.classList.add('breadcrumbs__list--opened')
            })
        }
    }
})